import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import ET3Div from "../../../../../core/et3-div";
import UserActionButtons from "./user-action-buttons";
import UserChangeUserName from "./user-change-username";
import UserChangeUserStatus from "./user-change-status";
import getCorePersonalStore from "../../../../../stores/core/core-personal-store";
import { ACTIONS_ROW_GAP } from "./modify-user-data-constants";

const ModifyUserData = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitX, unitY } = theme;
  const isAnyKhattabaAdmin = getCorePersonalStore().isAnyKhattabaAdmin.get();

  return isAnyKhattabaAdmin ? null : (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      withShadow={false}
      width={0}
      height={0}
      fDirection="column"
      alignItems="stretch"
      justifyContent="flex-start"
      color={colors.all.transparent}
      style={{ width: "100%", minWidth: 0 }}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        withShadow={false}
        width={0}
        height={0}
        fDirection="row"
        alignItems="flex-start"
        justifyContent="flex-start"
        color={colors.all.transparent}
        style={{
          width: "100%",
          minWidth: 0,
          flexWrap: "wrap",
          gap: `${ACTIONS_ROW_GAP * unitY}px ${ACTIONS_ROW_GAP * unitX}px`
        }}
        onClick={() => {}}
      >
        <UserChangeUserName />
        <UserChangeUserStatus />
        <UserActionButtons />
      </ET3Div>
    </ET3Div>
  );
});
export default ModifyUserData;
